import { useAuth } from "@/context/AuthContext";
import { useModulePermissions } from "@/context/ModulePermissionsContext";
import { useCompanyId } from "@/context/CompanyContext";
import { resolveClientsAppProfile } from "@/components/clients/clientsAppProfiles";
import { ClientsList } from "@/components/clients/ClientsList";

/** Routes Clients app layout by tenant / persona profile. */
export function ClientsAppShell() {
  const companyId = useCompanyId();
  const { user } = useAuth();
  const { permissions } = useModulePermissions();
  const profile = resolveClientsAppProfile(companyId, {
    role: user?.role,
    modules: permissions?.modules,
  });

  return <ClientsList profile={profile} />;
}
